<template>
  <div class="v-tdWrapper">
    <a :href="tagDescription.link_url" class="v-tdLink" :style="`background-image: url(${ tagDescription.image_url })`" :title="$t('TagDescription.urlTitle', { title: tagDescription.title })">
      <h3 class="v-tdTitle">{{ tagDescription.title }}</h3>
      <p class="v-tdDesc" v-html="tagDescription.description"></p>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    tagDescription: { type: Object, required: true },
  },

  name: 'TagDescription',
}
</script>

<style lang="scss" scoped>
.v-tdWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  margin: 30px 0 var(--contents-padding);
  border-radius: 4px;
  overflow: hidden;

  @media screen and (min-width: 1200px) {
    margin: 0 0 30px 0;
  }
}

.v-tdLink {
  display: block;
  position: relative;
  width: 100%;
  text-decoration: none;
  padding: 30px var(--contents-padding);
  background-size: cover;
  background-position: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
  }
}

.v-tdTitle {
  position: relative;
  font-family: var(--sans-serif-en);
  font-size: 18px;
}

.v-tdDesc {
  position: relative;
  font-size: 10px;
  text-align: center;
  line-height: 2.2;
  margin: 0;
}
</style>
